import { Box, Flex, Heading, Separator, Text } from "@chakra-ui/react";
import Header from "../utils/header";
import Footer from "../utils/footer";
import image1 from '../images/image6.jpg'
import image2 from '../images/image7.jpg'
import { FaArrowsUpDownLeftRight, FaClock, FaHandHoldingDollar, FaHandHoldingHand, FaHandshake, FaHandsHoldingChild, FaHeadset, FaMoneyBillWave, FaPeopleGroup, FaPeopleLine } from "react-icons/fa6";
import { AnimatedComponent } from "../utils/utils";

export default function Services() {
    
    return(
        <Box>
            <Header />
            <Box py={16} px={{ base: 3, md: 15 }}>
                <AnimatedComponent delay={0}>
                    <Heading textAlign="center" mb={10} color={"blue.500"} textStyle={"2xl"}>
                        Pelayanan Kami
                    </Heading>
                </AnimatedComponent>

                <Flex direction="column" gap={10}>
                {/* Konstruksi Bangunan Gedung */}
                    <AnimatedComponent delay={0}>
                        <Box id="konstruksi" bgImage={`url(${image1})`} borderRadius={20}>
                            <Box p={{base: 6, md: 10}} bgColor={"green.500/80"} borderRadius={20}>
                                <Heading size={{base:"lg",md:"2xl"}} color="yellow.200">
                                    Konstruksi Bangunan Gedung
                                </Heading>
                                <Separator my={2} />
                                <Text color="gray.700" fontSize="md" textAlign="justify">
                                    Kami menghadirkan layanan konstruksi bangunan gedung dengan standar profesional
                                    dan hasil yang kokoh, presisi, serta estetis. Setiap proyek dikerjakan oleh
                                    <strong> tim ahli berpengalaman </strong> yang memastikan setiap detail sesuai dengan
                                    kebutuhan dan harapan Anda. Dengan sistem kerja yang transparan dan terukur, kami
                                    siap mewujudkan bangunan berkualitas tinggi yang dapat diandalkan untuk jangka
                                    panjang baik untuk hunian, perkantoran, maupun fasilitas publik.
                                </Text>
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    {/* Konstruksi Industri */}
                    <AnimatedComponent delay={0}>
                        <Box bgImage={`url(${image2})`} borderRadius={20}>
                            <Box p={{base: 6, md: 10}} bgColor={"blue.500/80"} borderRadius={20}>
                                <Heading size={{base:"lg",md:"2xl"}} color="yellow.300">
                                    Konstruksi Industri
                                </Heading>
                                <Separator my={2} />
                                <Text color="gray.200" fontSize="md" textAlign="justify">
                                    Layanan konstruksi industri kami dirancang untuk mendukung efisiensi dan
                                    keberlanjutan bisnis Anda. Kami membangun fasilitas industri yang tangguh,
                                    fungsional, dan aman sesuai dengan <strong>standar teknik terbaik</strong>. Tim kami
                                    mampu menyesuaikan perencanaan dan pelaksanaan proyek dengan <strong>budget serta
                                    kebutuhan spesifik</strong> perusahaan Anda. Dengan <strong>komitmen tinggi terhadap
                                    kualitas dan waktu penyelesaian</strong>, kami menjadi mitra andal dalam mewujudkan
                                    area produksi yang produktif dan modern.
                                </Text>
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    {/* Renovasi/Perbaikan */}
                    <AnimatedComponent delay={0}>
                        <Box id="renovasi" bgImage={`url(${image1})`} borderRadius={20}>
                            <Box p={{base: 6, md: 10}} bgColor={"green.500/80"} borderRadius={20}>
                                <Heading size={{base:"lg",md:"2xl"}} color="yellow.200">
                                    Renovasi / Perbaikan Bangunan Rumah, Ruko, dan Lain Sebagainya
                                </Heading>
                                <Separator my={2} />
                                <Text color="gray.700" fontSize="md" textAlign="justify">
                                    Peremajaan bangunan menjadi lebih mudah dan terpercaya bersama kami.
                                    Kami melayani berbagai kebutuhan renovasi dan perbaikan — mulai dari rumah tinggal,
                                    ruko, hingga fasilitas komersial. Dengan <strong>layanan yang fleksibel dan responsif</strong>,
                                    kami memastikan hasil akhir yang rapi, aman, dan sesuai dengan keinginan Anda.
                                    Didukung oleh <strong>tenaga profesional yang berpengalaman</strong>, setiap proyek dikerjakan
                                    dengan ketelitian dan ketepatan waktu untuk menghadirkan hasil maksimal tanpa
                                    mengganggu aktivitas Anda.
                                </Text>
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    {/* Konsultasi Desain dan Perencanaan */}
                    <AnimatedComponent delay={0}>
                        <Box bgImage={`url(${image2})`} borderRadius={20}>
                            <Box p={{base: 6, md: 10}} bgColor={"blue.500/80"} borderRadius={20}>
                                <Heading size={{base:"lg",md:"2xl"}} color="yellow.300">
                                    Konsultasi Desain dan Perencanaan Konstruksi
                                </Heading>
                                <Separator my={2} />
                                <Text color="gray.200" fontSize="md" textAlign="justify">
                                    Sebelum membangun, rencanakan dengan matang bersama tim konsultan kami.
                                    Kami menawarkan <strong>layanan desain dan perencanaan konstruksi</strong> yang
                                    menyeluruh — dari konsep awal hingga visualisasi 3D. Dengan pendekatan
                                    kreatif dan profesional, kami membantu Anda menciptakan desain yang tidak
                                    hanya indah, tetapi juga efisien dan fungsional. Setiap solusi kami
                                    disesuaikan dengan karakter, kebutuhan, dan <strong>anggaran klien</strong>,
                                    agar proyek Anda berjalan lebih terarah dan optimal.
                                </Text>
                            </Box>
                        </Box>
                    </AnimatedComponent>
                </Flex>

                <AnimatedComponent delay={0}>
                    <Heading textAlign="center" color={"blue.500"} textStyle={"2xl"} mt={20} mb={10}>
                        Keuntungan Memilih Jasa Kami
                    </Heading>
                </AnimatedComponent>

                <Flex
                    direction={{ base: "column", md: "row" }}
                    justify="space-around"
                    align="start"
                    wrap="wrap"
                    gap={6}
                >
                    <AnimatedComponent delay={.3} flex="1">
                        <Box position={"relative"} bg="green.50" p={6} borderRadius="lg" shadow="md" minW="250px">
                            <Heading size="sm" color="green.700" mb={2} zIndex={2} position={"relative"}>
                                Tim Profesional & Berpengalaman
                            </Heading>
                            <Text color="gray.700" fontSize="sm" zIndex={2} position={"relative"}>
                                Dikerjakan oleh tenaga ahli di bidang konstruksi dan desain, kami menjamin
                                hasil kerja yang rapi, presisi, dan berkualitas tinggi di setiap proyek.
                            </Text>
                            <Box
                                position={"absolute"}
                                right={2}
                                bottom={1}
                                textStyle={"7xl"}
                                color="green.200/80"
                                zIndex={1}
                            >
                                <FaPeopleGroup />
                            </Box>
                            <Box
                                position={"absolute"}
                                left={1}
                                top={1}
                                textStyle={"4xl"}
                                color="green.200/80"
                                zIndex={1}
                            >
                                <FaPeopleLine />
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    <AnimatedComponent delay={.5} flex="1">
                        <Box position={"relative"} bg="green.50" p={6} h={"100%"} borderRadius="lg" shadow="md" minW="250px">
                            <Heading size="sm" color="green.700" mb={2} zIndex={2} position={"relative"}>
                                Layanan Fleksibel & Responsif
                            </Heading>
                            <Text color="gray.700" fontSize="sm" zIndex={2} position={"relative"}>
                                Tim kami siap melayani dengan cepat dan tanggap, memberikan solusi terbaik
                                sesuai kondisi di lapangan agar pekerjaan berjalan lancar tanpa hambatan.
                            </Text>
                            <Box
                                position={"absolute"}
                                left={2}
                                bottom={1}
                                textStyle={"7xl"}
                                color="green.200/80"
                                scale={"auto"}
                                scaleX={"-1"}
                                zIndex={1}
                            >
                                <FaArrowsUpDownLeftRight />
                            </Box>
                            <Box
                                position={"absolute"}
                                right={2}
                                top={1}
                                textStyle={"4xl"}
                                color="green.200/80"
                                rotate={"25deg"}
                                zIndex={1}
                            >
                                <FaHeadset />
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    <AnimatedComponent delay={.8} flex="1">
                        <Box position={"relative"} bg="green.50" p={6} borderRadius="lg" shadow="md" minW="250px">
                            <Heading size="sm" color="green.700" mb={2} zIndex={2} position={"relative"}>
                                Bisa Menyesuaikan Budget & Kebutuhan
                            </Heading>
                            <Text color="gray.700" fontSize="sm" zIndex={2} position={"relative"}>
                                Kami memahami bahwa setiap proyek memiliki skala dan prioritas berbeda.
                                Karena itu, kami selalu siap menyesuaikan rencana dan biaya agar sesuai
                                dengan anggaran Anda tanpa mengurangi kualitas hasil akhir.
                            </Text>
                            <Box
                                position={"absolute"}
                                right={2}
                                bottom={2}
                                textStyle={"7xl"}
                                color="green.200/80"
                                scale={"auto"}
                                scaleX={-1}
                                zIndex={1}
                            >
                                <FaHandHoldingDollar />
                            </Box>
                            <Box
                                position={"absolute"}
                                left={2}
                                top={2}
                                textStyle={"4xl"}
                                color="green.200/80"
                                rotate={"-25deg"}
                                zIndex={1}
                            >
                                <FaMoneyBillWave />
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    <AnimatedComponent delay={1.2} flex="1">
                        <Box position={"relative"} bg="green.50" p={6} borderRadius="lg" shadow="md" minW="250px">
                            <Heading size="sm" color="green.700" mb={2} zIndex={2} position={"relative"}>
                                Komitmen Kualitas & Ketepatan Waktu
                            </Heading>
                            <Text color="gray.700" fontSize="sm" zIndex={2} position={"relative"}>
                                Kami menempatkan kualitas sebagai prioritas utama dan selalu menjaga
                                ketepatan waktu dalam setiap proses pengerjaan proyek Anda.
                            </Text>
                            <Box
                                position={"absolute"}
                                left={2}
                                bottom={2}
                                textStyle={"7xl"}
                                color="green.200/80"
                                rotate={"-45deg"}
                                zIndex={1}
                            >
                                <FaClock />
                            </Box>
                            <Box
                                position={"absolute"}
                                right={2}
                                top={2}
                                textStyle={"4xl"}
                                color="green.200/80"
                                rotate={"40deg"}
                                zIndex={1}
                            > 
                                <FaHandHoldingHand/>
                            </Box>
                        </Box>
                    </AnimatedComponent>

                    <AnimatedComponent delay={1.5} flex="1">
                        <Box position={"relative"} bg="green.50" p={6} borderRadius="lg" shadow="md" minW="250px">
                            <Heading size="sm" color="green.700" mb={2} zIndex={2} position={"relative"}>
                                Membership & Kemitraan
                            </Heading>
                            <Text color="gray.700" fontSize="sm" zIndex={2} position={"relative"}>
                                Bergabunglah sebagai mitra atau anggota kami untuk mendapatkan akses
                                khusus terhadap layanan premium, promo proyek, dan dukungan berkelanjutan.
                            </Text>
                            <Box
                                position={"absolute"}
                                right={2}
                                bottom={1}
                                textStyle={"7xl"}
                                color="green.200/80"
                                scale={"auto"}
                                scaleX={"-1"}
                                zIndex={1}
                            >
                                <FaHandshake />
                            </Box>
                            <Box
                                position={"absolute"}
                                left={2}
                                top={1}
                                textStyle={"4xl"}
                                color="green.200/80"
                                rotate={"-25deg"}
                                zIndex={1}
                            >
                                <FaHandsHoldingChild />
                            </Box>
                        </Box>
                    </AnimatedComponent>
                </Flex>
            </Box>
            <Footer />
        </Box>
    );
}